export default "__VITE_ASSET__BCMWavoS__"